import { AppState } from '../root.reducer';

export const getOrganizationGroupManagement = (state: AppState) => state.organizationGroupManagement.organizations;

export const getOrganizationGroupManagementFilters = (state: AppState) => state.organizationGroupManagement.organizations.filters;

export const getOrganizationGroupManagementPagination = (state: AppState) => ({
  count: state.organizationGroupManagement.organizations.count,
  page: state.organizationGroupManagement.organizations.page,
});

export const getUnusedOrganizationGroups = (state: AppState) => state.organizationGroupManagement.unused;
